import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withFirebase } from '../Firebase';
import DragScrollProvider from 'drag-scroll-provider';
import * as ROUTES from '../../constants/routes';
import userProfilImage from '../assets/icon_user_profile.svg';
import DefaultProfileImg from '../assets/icon_user_profile.svg';
import Tooltip from '@material-ui/core/Tooltip';
import "./PeerLine.css";
import { Fade } from '@material-ui/core';

class PeerLine extends Component {

    render() {
        return (
            <PeerLineComponent myAssignments={this.props.myAssignments} />
        );
    }
}

const INITIAL_STATE = {
    managerID: '',
    users: [],
    peers: [],
    peersPictures: [],
    error: null,
};

class PeerLineComponentBase extends Component {

    constructor(props) {
        super(props);
        this.state = { ...INITIAL_STATE };
    }

    goToReceived = (context) => {
        context.props.history.push(ROUTES.RECEIVED);
    }

    componentDidMount() {

        this.props.firebase.auth.onAuthStateChanged(async (currentUser) => {

            if (currentUser === null) {
                return
            }

            let querySnapshotUsers = await this.props.firebase.db.collection('users').get()

            const currentUserInfos = await this.props.firebase.db.collection('users').doc(currentUser.uid).get()

            let peersPictures = [currentUserInfos.data().image_url_profile];
            const managerID = currentUserInfos.data().manager;
            const peers = querySnapshotUsers.docs
                .map(doc => doc.data())
                .filter(user => user.manager === managerID);

            peers.forEach(function (peer) {
                if (peer.image_url_profile !== peersPictures[0]) {
                    if (peer.image_url_profile !== null) {
                        peersPictures = peersPictures.concat([peer.image_url_profile])
                    }
                    else {
                        peersPictures = peersPictures.concat([userProfilImage])
                    }
                }

            })

            this.setState({ managerID, peers, peersPictures })


        });
    }


    render() {

        const picturesDisplay = [];
        const myAssignments = this.props.myAssignments || [];
        const nonProcessedAssignmentsKeys = myAssignments.filter(assignment => assignment.accepted === null)
        let context = this;

        this.state.peersPictures.forEach(function (value, index) {

            if (index === 0) {
                picturesDisplay.push(
                    <Fade in={true} key={index}>
                        <div className="own-profile-container">

                            <img className="own-profile-picture" src={value || DefaultProfileImg} alt="Profile" key={index} onError={context.props.firebase.profileImgError} />
                            {myAssignments.length > 0 ?
                                <Tooltip title="Mes capsules reçues" aria-label="aller dans reçues">
                                    <div className="peer-line-notif" onClick={() => context.goToReceived(context)}>{nonProcessedAssignmentsKeys.length}</div>
                                </Tooltip> : <></>}
                        </div>
                    </Fade>

                )
            }
            else {
                picturesDisplay.push(
                    <Fade in={true} key={index}>
                        <img className="small-pictures" src={value || DefaultProfileImg} alt="Profile" onError={context.props.firebase.profileImgError} />
                    </Fade>)
            }
        })

        return (

            <div>
                <div className="peer-title">
                    Mes pairs : les capsules d'amélioration
                </div>

                <div className="peer-line-container">
                    <DragScrollProvider>
                        {({ onMouseDown, ref }) => (
                            <div className="peer-line peer-scrolling-wrapper"
                                ref={ref}
                                onMouseDown={onMouseDown}>

                                {picturesDisplay}

                            </div>
                        )}
                    </DragScrollProvider>
                </div>
            </div>
        );
    }
}

const PeerLineComponent = withRouter(withFirebase(PeerLineComponentBase));


export default PeerLine;
export { PeerLineComponent };